import React, { useState } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Flex,
  Badge,
  VStack,
  HStack,
  Stack,
  List,
  ListItem,
  ListIcon,
  Button,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Grid,
  GridItem,
  Divider,
} from "@chakra-ui/react";
import { CheckIcon, InfoIcon, SettingsIcon, StarIcon } from "@chakra-ui/icons";
import { FiZap } from "react-icons/fi";
import CombinedHeading from "../../common/CombinedHeading";
import { linksConfig } from "../../../utils/CommonLinks";
// Table data
const configurations = [
  { cpu: "AMD 9254", memory: "384 GB", price: "$1800/month", alternate: false },
  { cpu: "AMD 7543", memory: "1 TB", price: "$2000/month", alternate: true },
  { cpu: "AMD 9354", memory: "512 GB", price: "$2200/month", alternate: false },
  { cpu: "AMD 9354", memory: "768 GB", price: "$2500/month", alternate: true },
  { cpu: "AMD 9354", memory: "1 TB", price: "$2800/month", alternate: false },
];
const GRPCPricingSection = () => {
  // Custom colors to match the design
  const bgColor = "#101010";
  const cardBg = "#181818";
  const tabBg = "#181818";
  const activeTabBg = "#E33535";
  const primaryColor = "#E33535";
  const secondaryColor = "#FBB901";
  const borderColor = "#333333";
  const textColor = "#FFFFFF";
  const textMuted = "rgba(255, 255, 255, 0.7)";
  const textLight = "rgba(255, 255, 255, 0.5)";

  return (
    <Box as="section" bg={bgColor} color={textColor}>
      <Container maxW="1200px" px={5}>
        {/* Header */}
        {/* <Box textAlign="center" mb={10}>
          <Text color={secondaryColor} fontWeight="500" mb={3}>
            Simple and Transparent Plans
          </Text>
          <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }} fontWeight="800" mb={4}>
            gRPC Infrastructure
          </Heading>
          <Text color={textMuted} maxW="600px" mx="auto" fontSize="md">
            Choose the right infrastructure for your Solana project needs
          </Text>
        </Box> */}
        <Box pb={16}>
          <CombinedHeading
            topHeading={"Cost Effective"}
            mainHeading={"Pricing That Makes Sense"}
            subHeading={
              "No credits, no complex metering system. Straightforward pricing to get you started."
            }
            isCenter={true}
          />
        </Box>

        {/* Pricing Tabs */}
        <Tabs variant="unstyled" isFitted mb={10}>
          <TabList
            border="1px solid"
            borderColor={"brand.faintGrey"}
            borderRadius="8px"
            mb={8}
            mx="auto"
            width={{ base: "100%", md: "60%" }}
          >
            <Tab
              py={4}
              px={8}
              color={"brand.white"}
              bg={"transparent"}
              fontWeight="600"
              borderRadius="8px 0 0 8px"
              _selected={{
                bg: "brand.red",
                color: "brand.white",
              }}
              _hover={{
                bg: "brand.white",
                color: "brand.red",
              }}
            >
              Shared Network
            </Tab>
            <Tab
              py={4}
              px={8}
              color={textColor}
              bg={tabBg}
              fontWeight="600"
              borderRadius="0 8px 8px 0"
              _selected={{
                bg: "brand.red",
                color: "brand.white",
              }}
              _hover={{
                bg: "brand.white",
                color: "brand.red",
              }}
            >
              Dedicated Nodes
            </Tab>
          </TabList>

          <TabPanels>
            {/* Shared gRPC Network Panel */}
            <TabPanel p={0}>
              <Box
                bg={"transparent"}
                borderRadius="xl"
                border="1px solid"
                borderColor={"brand.faintGrey"}
                overflow="hidden"
                boxShadow="lg"
              >
                <Flex
                  direction={{ base: "row", md: "row" }}
                  borderBottom="1px solid"
                  borderColor={"brand.faintGrey"}
                >
                  <Box flex="1" p={{ base: 6, md: 6 }}>
                    {/* <Badge
                      bg="rgba(251, 185, 1, 0.2)"
                      color={secondaryColor}
                      px={3}
                      py={1}
                      borderRadius="md"
                      fontSize="sm"
                      mb={2}
                    >
                      SHARED INFRASTRUCTURE
                    </Badge> */}
                    <Heading as="h3" fontSize={{ base: "2xl", md: "3xl" }} mt={2}>
                      Shared gRPC Network
                    </Heading>
                    <Text color={textLight} fontSize={{base:"sm", md: "md"}}>
                    All nodes are powered by Shredstreams for lowest latency. 
                    Experience lag-free streaming with our advanced load balancers.
                    </Text>
                  </Box>
                  <Flex
                    direction="column"
                    align={{ base: "flex-start", md: "flex-end" }}
                    justifyContent="center"
                    p={{ base: 6, md: 8 }}
                    borderLeft={{ base: "1px solid", md: "1px solid" }}
                    borderColor={"brand.faintGrey"}
                    textAlign={"right"}
                  >
                    <Heading
                      as="h4"
                      fontSize={{ base: "3xl", md: "4xl" }}
                      lineHeight="1"
                    >
                      $199
                    </Heading>
                    <Text fontSize="sm" color={textLight}>
                      per month / per IP
                    </Text>
                  </Flex>
                </Flex>

                <Box p={{ base: 6, md: 8 }}>
                  <Grid
                    templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                    gap={8}
                  >
                    <Box>
                      <HStack align="center" mb={4}>
                        <FiZap color={primaryColor} boxSize={6} />
                        <Heading as="h5" fontSize="xl" fontWeight="600" mt={2}>
                          Key Features
                        </Heading>
                      </HStack>
                      <List spacing={3}>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          No credits or metering system
                        </ListItem>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          Lag Free streaming with our advanced load balancers
                        </ListItem>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          Accelerated with Shredstreams
                        </ListItem>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          Select from multiple global regions
                        </ListItem>
                      </List>
                    </Box>

                    <Box>
                      <HStack align="center" mb={4}>
                        <SettingsIcon color={primaryColor} boxSize={4} />
                        <Heading as="h5" fontSize="lg" fontWeight="600" mt={2}>
                          gRPC Limits
                        </Heading>
                      </HStack>
                      <List spacing={3}>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          50 Concurrent streams
                        </ListItem>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          Connect to multiple regions from same IP
                        </ListItem>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          50 subscribe request/min. (can be tweaked)
                        </ListItem>
                        <ListItem fontSize="sm" color={textMuted}>
                          <ListIcon as={CheckIcon} color={primaryColor} />
                          Discounts on additional IP connections
                        </ListItem>
                      </List>
                    </Box>
                  </Grid>

                  <Flex
                    mt={{base: 6, md: 12}}
                    mb={{base: 4, md: 0}}
                    direction={{ base: "column", md: "column" }}
                    align={{ base: "center", md: "center" }}
                    justify="start"
                    gap={4}
                  >
                    <Button
                      as={"a"}
                      href="/dashboard/grpc"
                      bg={"brand.red"}
                      color="white"
                      size={{base: "md", md: "lg"}}
                      fontWeight="400"
                      fontFamily={"heading"}
                      px={8}
                      pb={1}
                      w={{base: "220px", md: "240px"}}
                      borderRadius={"full"}
                      _hover={{
                        bg: "brand.white",
                        color: "brand.red",
                      }}
                      
                    >
                      Start gRPC Streaming
                    </Button>
                    {/* <Text color={textLight} fontSize="sm">
                      Need help? Reach out to us on Discord for queries.
                    </Text> */}
                  </Flex>
                </Box>
              </Box>
            </TabPanel>

            {/* Dedicated gRPC Nodes Panel */}
            <TabPanel p={0}>
              <Box
                bg={"transparent"}
                borderRadius="xl"
                border="1px solid"
                borderColor={"brand.faintGrey"}
                overflow="hidden"
                boxShadow="lg"
              >
                <Flex
                  direction={{ base: "row", md: "row" }}
                  borderBottom="1px solid"
                  borderColor={borderColor}
                >
                  <Box flex="1" p={{ base: 6, md: 8 }}>
                    <Badge
                      bg="rgba(251, 185, 1, 0.2)"
                      color={secondaryColor}
                      px={3}
                      py={1}
                      borderRadius="sm"
                      fontSize={{ base: "2xs", md: "sm" }}
                      mb={2}
                    >
                      ENTERPRISE GRADE
                    </Badge>
                    <Heading
                      as="h3"
                      fontSize={{ base: "2xl", md: "3xl" }}
                      mb={2}
                    >
                      Dedicated gRPC Nodes
                    </Heading>
                    <Text color={textMuted} fontSize={{ base: "sm", md: "md" }}>
                      Exclusive high-performance nodes with Shred acceleration and intelligent load balancers.
                    </Text>
                  </Box>
                  <Flex
                    direction="column"
                    align={{ base: "start", md: "flex-end" }}
                    justifyContent={{ base: "center", md: "center" }}
                    px={{ base: 6, md: 8 }}
                    pt={{ base: 0, md: 8 }}
                    borderLeft={ "1px solid" }
                    borderColor={"brand.faintGrey"}
                    textAlign={"right"}
                    // borderTop={{ base: "1px solid", md: "none" }}
                  >
                    <Text color={"brand.midGrey"} fontSize={{ base: "xs", md: "sm" }} >
                      Starting from
                    </Text>
                    <Heading
                      as="h4"
                      fontSize={{ base: "3xl", md: "4xl" }}
                      lineHeight={0.4}
                    >
                      $1800
                    </Heading>
                    <Text fontSize={{ base: "xs", md: "sm" }} color={"brand.midGrey"} lineHeight={{base:"2rem", md: "2.2rem"}}>
                      per month
                    </Text>
                  </Flex>
                </Flex>

                <Box p={{ base: 6, md: 8 }}>
                  <Grid
                    templateColumns={{ base: "1fr", md: "6fr 7fr" }}
                    gap={8}
                  >
                    <Box>
                      <Box>
                        <HStack align="center" mb={4}>
                          <FiZap color={primaryColor} boxSize={8} />
                          <Heading
                            as="h5"
                            fontSize="xl"
                            fontWeight="500"
                            mt={1}
                          >
                            Key Features
                          </Heading>
                        </HStack>
                        <List spacing={3}>
                          <ListItem fontSize="sm" color={textMuted}>
                            <ListIcon as={CheckIcon} color={primaryColor} />
                              Get direct access to the node without any load balancer.
                          </ListItem>
                          <ListItem fontSize="sm" color={textMuted}>
                            <ListIcon as={CheckIcon} color={primaryColor} />
                              Upto 50ms faster than shared network.
                          </ListItem>
                          <ListItem fontSize="sm" color={textMuted}>
                            <ListIcon as={CheckIcon} color={primaryColor} />
                              Accelerated with Shredstreams.
                          </ListItem>
                          <ListItem fontSize="sm" color={textMuted}>
                            <ListIcon as={CheckIcon} color={primaryColor} />
                            Isolated from any traffic/impact from shared infra.
                          </ListItem>
                          <ListItem fontSize="sm" color={textMuted}>
                            <ListIcon as={CheckIcon} color={primaryColor} />
                            Priority support and direct communication with Shyft devs.
                          </ListItem>
                        </List>
                      </Box>
                    </Box>

                    <Box>
                      <Box
                        border={"1px solid"}
                        borderColor={"brand.faintGrey"}
                        paddingX={4}
                        paddingY={4}
                        borderRadius={"10px"}
                      >
                        {/* Table Header */}
                        <Heading as="h5" fontSize="lg" fontWeight="500">
                          Available Configurations
                        </Heading>
                        <Box pt={2} fontSize={{base: "xs", md: "md"}}>
                          <Grid
                            templateColumns="1fr 3fr 1fr"
                            bg={"brand.red"}
                            color={"brand.lighterWhite"}
                            fontWeight="600"
                            p={3}
                            borderTopRadius="md"
                          >
                            <GridItem>Config</GridItem>
                            <GridItem></GridItem>
                            <GridItem textAlign={"center"} pe={5}>
                              Price
                            </GridItem>
                          </Grid>

                          {/* Table Rows */}
                          {configurations.map((config, index) => (
                            <Grid
                              key={index}
                              templateColumns="1fr 1fr 1fr"
                              bg={config.alternate ? "#111" : "#000"}
                              p={3}
                              justifyContent={"space-between"}
                              borderBottom={`1px solid`}
                              borderColor={
                                index === configurations.length - 1
                                  ? "brand.red"
                                  : "transparent"
                              }
                              fontSize={{base: "xs", md: "md"}}
                            >
                              <GridItem color={"brand.lighterWhite"}>
                                {config.cpu}/{config.memory}
                              </GridItem>
                              <GridItem></GridItem>

                              <GridItem
                                color={"brand.lighterWhite"}
                                textAlign={"end"}
                              >
                                {config.price}
                              </GridItem>
                            </Grid>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  <Flex
                    mt={{base: 8, md: 8}}
                    mb={2}
                    direction={{ base: "column", md: "row" }}
                    align={{ base: "center", md: "center" }}
                    justify="center"
                    gap={4}
                  >
                    <Button
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      bg={"brand.red"}
                      color="white"
                      size={{base:"md", md: "lg"}}
                      fontWeight="400"
                      fontFamily={"heading"}
                      px={{base: "20px", md: 8}}
                      borderRadius={"full"}
                      _hover={{
                        bg: "brand.white",
                        color: "brand.red",
                      }}
                    >
                      Connect with us
                    </Button>
                  </Flex>
                </Box>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>

        {/* Note Box */}
        {/* <Box
          bg="rgba(251, 185, 1, 0.05)"
          borderRadius="md"
          p={4}
          fontSize="sm"
          color={textMuted}
          borderLeft="3px solid"
          borderColor={secondaryColor}
        >
          <HStack align="flex-start" spacing={2}>
            <InfoIcon color={secondaryColor} mt={1} />
            <Text>
              <Text as="span" fontWeight="600" color={secondaryColor}>
                Note:
              </Text>{" "}
              For dedicated nodes, we suggest running separate nodes for RPC and
              gRPC usage for optimal performance. Indexes can be enabled only on
              1TB nodes. All prices are in USD.
            </Text>
          </HStack>
        </Box> */}
      </Container>
    </Box>
  );
};

export default GRPCPricingSection;
